module.exports = __webpack_public_path__ + "static/media/guideIntegration.ad27dd47.md";